/**
 * Takes a bunch of properties with keys that are in snake_case and returns a new object with the same properties but with keys in camelCase.
 * This assists with converting the Ruby has keys in snake_case to JavaScript that has keys in camelCase.
 * Generally the input `trackerOptionsConfig` is the result of using the `TrackerHelper::tracker_options_config` method on the Ruby side.
 * @param trackerOptionsConfig {Object} An object specific `Tracker` configuration keys in snake_case.
 * @returns {Object} An object with the Javascript `Tracker` configuration properties.
 */
export function getTrackerOptions(trackerOptionsConfig) {
    if (!trackerOptionsConfig) return;
    return {
        isNativeApp: (trackerOptionsConfig['is_native_app'] ?? null),
        nativeAppPlatform: (trackerOptionsConfig['native_app_platform'] ?? null),
        nativeAppVersion: (trackerOptionsConfig['native_app_version'] ?? null),
        nativeAppUrlScheme: (trackerOptionsConfig['native_app_url_scheme'] ?? null),
        nativeEventHost: (trackerOptionsConfig['native_event_host'] ?? null),
        nativeEventEndpoint: (trackerOptionsConfig['native_event_endpoint'] ?? null),
    }
}
